// extracted by mini-css-extract-plugin
module.exports = {"agenda":"Agenda_agenda__NkGOS","header":"Agenda_header__02lwp","title":"Agenda_title__X86Rd"};